export default __webpack_public_path__ + "static/media/ic_export.67acd57f.svg";